import { Paper, Button, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import Chart from "react-google-charts";
import { useDispatch } from 'react-redux';

import data from '../../app/api/fan.json'
import { changeOctaveBandPoint } from '../../app/reducer/project.reducer';

export default function OctaveBand({...props}:any) {
  const [graphData, setGraphData] = React.useState<any[]>([]);
  const dispatch = useDispatch()
  
  useEffect(() => {

    populateGraphDataFromProps()

  }, [props.data.dB]);

  const onPlotpointChage = (index:number,value:number) => {

    dispatch(changeOctaveBandPoint({index:index-1,value}))

  }
  
  const populateGraphDataFromProps = async () => {

    const { dB } = props.data;

    let tempGraphData = [];

    let graphHeaderData = ['Hz','db(A)']
    let OctaveArr = ['31.5','63','125','250','500','1000','2000','4000','8000','16000']
    tempGraphData.push(graphHeaderData);

    for (let i = 0; i < dB.length; i++) {
      
      let GraphDataRow = [];

      GraphDataRow.push(OctaveArr[i])
      GraphDataRow.push(dB[i])

      tempGraphData.push(GraphDataRow);

    }

    setGraphData(tempGraphData);

  }

  if(props.onlyGraph){
    return(
      <Chart
          width={'100%'}
          height={'700px'} 
          chartType="ColumnChart"
          loader={<div>Loading Chart</div>}
          data={
            graphData
            // [
            //   [ 'Octave', 'db(A)'],
            //   [ '31.5', 51.3],
            //   [ '63', 59.7],
            //   [ '125', 60.7],
            //   [ '250', 63.8],
            //   [ '500', 60.8],
            //   [ '1000', 60.8],
            //   [ '2000', 57.8],
            //   [ '4000', 55.2],
            //   [ '8000', 49.3],
            //   [ '16000', 39.4],
            // ]
          }
          options={{
            legend: {
    textStyle: {
      fontSize: 17, // 🔥 increase this
    },
  },
            chartArea: {
            height: '95%', // 🔥 makes bars taller
            width: '85%',
          },
            hAxis: {
              title: 'Hz',
              textStyle: {
        fontSize: 22, // 🔹 x-axis labels
      },
      titleTextStyle: {
        fontSize: 18, // 🔹 x-axis title
        bold: true,
      },
            },
            vAxis: {
              title: 'db(A)',
              textStyle: {
        fontSize: 22, // 🔹 x-axis labels
      },
      titleTextStyle: {
        fontSize: 18, // 🔹 x-axis title
        bold: true,
      },
            },
            series: {
              1: { curveType: 'function' }
            },
          }}
        />
    )
  }else{
    return (
      <div style={{
        display:'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '1200px',
        padding: '0px'
      }}>
        <Typography variant="h5" gutterBottom>
          <b>Octave Band Table</b>
        </Typography>
        {/* <TableContainer style={{width:'200px'}}> */}
          <Table aria-label="simple table" size="small" style={{zoom:0.8}}>
            <TableHead>
                <TableRow>
                <TableCell align="right"><Typography variant="h5">Octave (Hz)</Typography></TableCell>
                {graphData.map((row,index) => (
                  (index!==0?
                    <TableCell component="th" scope="row" key={row[0]}>
                      <Typography variant="h5">{row[0]}</Typography>
                    </TableCell>
                  :null)
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
              <TableCell align="right"><Typography variant="h5">SPL dB(A)</Typography></TableCell>
              {graphData.map((row,index) => (
                (index!==0?
                  <TableCell align="right"><TextField variant="outlined" placeholder='Blank' type="number" onChange={e=>onPlotpointChage(index,parseFloat(e.target.value))} value={row[1]} /></TableCell>
                :null)
              ))}
              </TableRow>
            </TableBody>
          </Table>
        {/* </TableContainer> */}
        <br/>
        <br/>
        {/* <Divider /> */}
        <br/>
        <Typography variant="h5" gutterBottom>
          <b>Octave Band Graph</b>
        </Typography><br/>
        <Chart
          width={'100%'}
          height={'400px'}
          chartType="Bar"
          loader={<div>Loading Chart</div>}
          data={
            graphData
            // [
            //   [ 'Octave', 'db(A)'],
            //   [ '31.5', 51.3],
            //   [ '63', 59.7],
            //   [ '125', 60.7],
            //   [ '250', 63.8],
            //   [ '500', 60.8],
            //   [ '1000', 60.8],
            //   [ '2000', 57.8],
            //   [ '4000', 55.2],
            //   [ '8000', 49.3],
            //   [ '16000', 39.4],
            // ]
          }
          options={{
            hAxis: {
              title: 'Hz',
            },
            vAxis: {
              title: 'db(A)',
            },
            series: {
              1: { curveType: 'function' }
            },
          }}
        />
        <br/>
        <Button
              // type="submit"
              variant="contained"
              color="primary"
              size="large"
              onClick={e=>props.setIndex(3)}
        >
              Next
        </Button>
      </div>
    )
  }
}
